import React from "react"
import badge from "badges/adventurous.svg"
import { BadgeImage } from "backpack/badges/styled"

const Adventurous = props => <BadgeImage src={badge} {...props} />

export default Adventurous
